//@refresh
"use client";
import React, { useContext, useEffect } from "react";
import { animationCreate } from "@/utils/utils";
import MemoFooter from "./footer/MemoFooter";
import BacktoTop from "@/components/common/backToTop/BacktoTop";

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}
import { usePathname } from "next/navigation";
import MemoHeader from "./header/MemoHeader";
import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import { useRouter } from "next/navigation";

interface WrapperProps {
  children: React.ReactNode;
}

const Wrapper: React.FC<WrapperProps> = ({ children }) => {
  const { locale, currentUser } = useContext(AppContext) as AppContextType;
  const router = useRouter();

  const pathName = usePathname();
  useEffect(() => {
    setTimeout(() => {
      animationCreate();
    }, 200);
  }, []);

  return (
    <>
      <BacktoTop />
      {(() => {
        switch (pathName) {
          case "/":
            return <MemoHeader />;
          default:
            return <MemoHeader />;
        }
      })()}
      <main className="main-content">{children}</main>
      {(() => {
        switch (pathName) {
          default:
            return <MemoFooter />;
        }
      })()}
    </>
  );
};

export default Wrapper;
